// Operations › Profit in Blueprint (BL-136; once Home › Profit, pages/ux-full screens/ads.js:
// #/home/profit, #/home/profit/jobs): who sees the pages. The views are ui-web's (ProfitViews.tsx), drawn
// from reports.jobCosting, jobs.get, gp.pace and gp.huddle. Job costing is finance.margins.view's: the
// owner's, and whoever holds a role of the owner's own that gives it (BL-137), so the page asks for the
// permission itself, never a role (P-0164).

/** The permission behind job costing and gross profit (packages/auth permissions.ts). */
export const PROFIT_PERMISSION = 'finance.margins.view';

/** Who sees job costing: whoever holds finance.margins.view. */
export const mayProfit = (permissions: readonly string[]): boolean => permissions.includes(PROFIT_PERMISSION);
